import { SET_INCREMENT_LIST, UNSET_INCREMENT_LIST } from "@/store/mutation-types";

// initial state
const state = {
    getHrmIncrementList: [],
    editingIncrement: null,
}

const getters = {
    getHrmIncrementList(state){
        return state.getHrmIncrementList;
    },
    getEditingIncrement: (state) => { 
        return state.editingIncrement;
    },
}

const mutations = {
    [SET_INCREMENT_LIST](state, data) {
        state.getHrmIncrementList = data;
    },
    [UNSET_INCREMENT_LIST](state) {
        state.getHrmIncrementList = [];
    },
    setEditingIncrement(state, increment) {
        state.editingIncrement = increment;
    },
    clearEditingIncrement(state) {
        state.editingIncrement = null;
    }
}

const actions = {
    // Actions will be handled by the service layer
}

export default {
    state,
    getters,
    mutations,
    actions
}
